import React, { useCallback, useEffect, useState, useMemo } from "react";
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import GrillaVacia from '../../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { Box } from "@mui/material";
import toast from 'react-hot-toast';
import DocumentViewer from "../../../../components/DocumentViewer";

export const EstudiosComplementarios = ({
    handleChange,
    name,
    prevAdjuntos,
    setChildrenAction,
    onDeleteAdjunto,
    readOnly = false
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [estudiosAdjuntos, setEstudiosAdjuntos] = useState(Array.isArray(prevAdjuntos) ? [...prevAdjuntos] : []);
    const [estudioAux, setEstudioAux] = useState({});
    const [openPreview, setOpenPreview] = useState(false);

    useEffect(() => {
        setEstudiosAdjuntos(Array.isArray(prevAdjuntos) ? prevAdjuntos?.map(x => {
            return {
                ...x,
                file: { ...x }
            }
        }) : []);
    }, [prevAdjuntos]);

    useEffect(() => {
        if (!estudiosAdjuntos?.length) return setChildrenAction(null);

        setChildrenAction(() => (
            <CustomButton
                onClick={handleOpenModal}
                size='small'
                variant='outlined'
                disabled={readOnly}
            >
                Agregar
            </CustomButton>
        ));

    }, [estudiosAdjuntos, readOnly]);

    const columns = generateColumnsDefaultConfiguration([
        {
            field: 'action',
            headerName: '',
            flex: 0.1,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    !readOnly && <DeleteOutlineIcon className='edit-icon' onClick={() => deleteAdjunto(row)} />
                )
            }
        },
        {
            headerName: 'Nombre del estudio',
            field: 'titulo',
            flex: 0.6
        },
        {
            field: 'action2',
            headerName: 'Adjunto',
            flex: 0.3,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <AttachFileOutlinedIcon className='edit-icon' onClick={() => editEstudio(row)} />
                )
            }
        },
    ]);

    const handleChangeImage = useCallback(async (nuevoEstudio) => {
        try {
            var image = await obtenerDataImagen(nuevoEstudio);

            const updateFile = {
                contentType: image?.tipo,
                archivo: image?.data,
                extension: image?.extension,
                titulo: image?.nombre
            };

            const updatedEstudio = { ...estudioAux, file: { ...updateFile } };

            setEstudioAux(structuredClone(updatedEstudio));
        }
        catch (error) {
            console.log(error);
        }
    }, [estudioAux, setEstudioAux]);

    const handleNameEstudio = (value) => {
        setEstudioAux((prevEstudio) => {
            return { ...prevEstudio, titulo: value }
        });
    }

    const handleClose = () => {
        setEstudioAux({});
        setOpenModal(false);
    }

    const handleAccept = () => {
        if (!estudioAux?.file) {
            toast.error('Debe adjuntar un archivo.');
            return;
        }

        const nuevoAdjunto = { ...estudioAux?.file, titulo: estudioAux?.titulo };

        handleChange(name, nuevoAdjunto);

        if (estudiosAdjuntos.some(e => e.idArchivo === nuevoAdjunto?.idArchivo)) {
            setEstudiosAdjuntos((prevEstudios) =>
                prevEstudios.map(estudio => {
                    if (estudio.idArchivo === nuevoAdjunto.idArchivo) {
                        return { ...nuevoAdjunto };
                    }
                    return estudio;
                })
            );
        } else {
            setEstudiosAdjuntos((prevEstudios) => [...prevEstudios, nuevoAdjunto]);
        }
        handleClose();
    };

    const handleOpenModal = () => setOpenModal(true);

    const handlePreview = () => {
        if (estudioAux?.file) {
            setOpenPreview(true);
        }
    }

    const deleteAdjunto = useCallback(async (estudio) => {
        onDeleteAdjunto(name, estudio.idArchivo, estudiosAdjuntos);
        setEstudiosAdjuntos((prevEstudios) => [...prevEstudios.filter((element) => element.idArchivo !== estudio.idArchivo)]);
    }, [setEstudiosAdjuntos, estudiosAdjuntos]);

    const onDeleteImage = () => {
        setEstudioAux({ titulo: estudioAux.titulo ?? '' });
    }

    const editEstudio = useCallback((estudio) => {
        setEstudioAux({ ...estudio });
        setIsEditing(true);
    }, [setEstudioAux]);

    useEffect(() => {
        if (isEditing && estudioAux?.idArchivo) {
            setOpenModal(true);
            setIsEditing(false);
        }
    }, [isEditing, estudioAux]);

    return (
        <>
            {!estudiosAdjuntos?.length && <div className='resumen-ingreso-grilla-vacia'>
                <div className='svg-clientes-grilla-vacia'>
                    <img src={GrillaVacia} width='100%'></img>
                </div>
                <label>No se ha agregado ningún estudio</label>
                <CustomButton
                    sx={{ mt: 2 }}
                    onClick={handleOpenModal}
                    size='small'
                    disabled={readOnly}
                >
                    Agregar
                </CustomButton>
            </div>}
            {!!estudiosAdjuntos.length && (
                <Box sx={{ width: '100%' }}>
                    <DataGridGenerico
                        columns={columns}
                        rows={estudiosAdjuntos}
                        toolbar={false}
                        hideFooter
                    />
                </Box>
            )}
            <CustomDialog
                maxWidth='md'
                fullWidth
                onCancel={handleClose}
                open={openModal}
                cancelText='Cerrar'
                onAccept={handleAccept}
                acceptDisabled={!estudioAux.titulo || readOnly}
                disabled={readOnly}
                acceptText='Aceptar'
                title='Estudios Adjuntos'
            >
                <RenderInputByTypeMobile
                    grided
                    handleChange={(_, value) => handleNameEstudio(value)}
                    input={{
                        name: 'nombreEstudio',
                        displayName: 'Nombre del estudio',
                        type: 'string',
                        required: true
                    }}
                    value={estudioAux?.titulo || ''}
                />
                <RenderInputByTypeMobile
                    grided
                    handleChange={(_, value) => handleChangeImage(value)}
                    input={{
                        name: 'estudioAdjunto',
                        displayName: 'Adjuntar estudio',
                        type: 'file',
                        validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
                        required: true,
                        disabled: readOnly,
                        maxFileSize: 8,
                        onDeleteImage: () => onDeleteImage(),
                    }}
                    onClickImagen={handlePreview}
                    value={estudioAux.file || null}

                />
            </CustomDialog>
            {openPreview && <DocumentViewer data={estudioAux.file} setOpenDlg={setOpenPreview} download={true} />}
        </>
    )
}